import services from '../services'
import * as types from './mutation-types'

export const getList = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_SURVEYS, res.data)
  })
)

export const show = async ({ commit }, params) => {
  await services.find(params).then(res => {
    commit(types.SET_SURVEY, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_SURVEY, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const changeSurvey = async ({ commit }) => {
  await services.changeSurvey().then(res => {
    return res
  })
}

export const orderList = async ({ commit }, obj) => {
  if (obj.itens) {
    await services.orderList(obj).then(res => {
      commit(types.SET_SURVEYS, res.data)
    })
  }
}

export const deleteAsking = async ({ commit }, obj) => {
  await services.deleteAsking(obj).then(res => {
    return res
  })
}

export const deleteAnswer = async ({ commit }, obj) => {
  await services.deleteAnswer(obj).then(res => {
    return res
  })
}
